module.exports = __webpack_public_path__ + "static/guitar-hero-3-690b94f11e76017694eb655b6b01e25e.jpg";